import { contact } from '../../portfolio'
import './Contact.css'

const Contact = () => {
  if (!contact.email) return null

  return (
    <section className='section contact center' id='contact'>
      <h2 className='section__title'>Contact Me On LinkedIn</h2>
      <a href='https://www.linkedin.com/in/yash-saini-3aab02250/'>
        <span type='button' className='btn btn--outline' data-aos='zoom-out' data-aos-duration="800">
          LinkedIn
        </span>
      </a>
    </section>
  )
}

export default Contact
